<a
  fxLayout="row"
  fxLayoutAlign="start center"
  class="u-borderBottom-standard u-display-block c-notificationItem u-padding-24"
  [ngClass]="{ 'is-unread': !notification.read }"
  [href]="notification.url"
  (click)="onNotificationClick(notification)"
>
  <div fxFlex="32px" class="u-marginRight-24">
    <app-avatar
      [imageUrl]="notification.actors[0].image_url || defaultImageUrl"
      class="u-display-block"
    >
    </app-avatar>
  </div>
  <div>
    <div>{{ notification.title.text }}</div>
    <div class="color-grey-300">{{ notification.created_at | appTimeAgo }}</div>
  </div>
</a>
